import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/tradingSystem/new-tag.png'
import _imports_1 from '../../assets/img/bidEvaluationTools/time.png'
import _imports_2 from '../../assets/img/tradingSystem/npapp.png'
import _imports_3 from '../../assets/img/delstep.svg'
import _imports_4 from '../../assets/img/addstep.svg'
import _imports_5 from '../../assets/img/tradingSystem/noimg.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3529ea18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box2" }
const _hoisted_2 = { class: "box2-top" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = {
  key: 0,
  class: "content"
}
const _hoisted_5 = {
  class: "platformtype-title",
  style: {"border-bottom":"1px solid #EBEBED"}
}
const _hoisted_6 = { class: "contentbox" }
const _hoisted_7 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_8 = { class: "center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "new-tag"
}
const _hoisted_11 = { class: "center2" }
const _hoisted_12 = { class: "top2" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "infobox" }
const _hoisted_15 = { class: "text-box1" }
const _hoisted_16 = { class: "text-box" }
const _hoisted_17 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_19 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_20 = { class: "center" }
const _hoisted_21 = { class: "noplatform" }
const _hoisted_22 = {
  class: "platformtype-title",
  style: {"margin-top":"16px"}
}
const _hoisted_23 = { class: "municipality-title" }
const _hoisted_24 = { class: "municipality-name" }
const _hoisted_25 = { class: "municipality-total" }
const _hoisted_26 = ["onMouseenter", "onMouseleave"]
const _hoisted_27 = { style: {"position":"relative","width":"1153px","margin":"0 auto"} }
const _hoisted_28 = { class: "contentbox2" }
const _hoisted_29 = { class: "center" }
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "new-tag"
}
const _hoisted_32 = {
  key: 1,
  class: "cityName"
}
const _hoisted_33 = { class: "center2" }
const _hoisted_34 = { class: "top2" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "infobox" }
const _hoisted_37 = { class: "text-box1" }
const _hoisted_38 = { class: "text-box" }
const _hoisted_39 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_41 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_42 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_43 = { class: "center" }
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "new-tag"
}
const _hoisted_46 = {
  key: 1,
  class: "cityName"
}
const _hoisted_47 = { class: "center2" }
const _hoisted_48 = { class: "top2" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "infobox" }
const _hoisted_51 = { class: "text-box1" }
const _hoisted_52 = { class: "text-box" }
const _hoisted_53 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_55 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    class: "appimg3",
    style: {"border":"none"}
  })
], -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = {
  key: 1,
  class: "content"
}
const _hoisted_64 = {
  key: 0,
  class: "searchBox"
}
const _hoisted_65 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_66 = { class: "center" }
const _hoisted_67 = ["src"]
const _hoisted_68 = { class: "center2" }
const _hoisted_69 = { class: "top2" }
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "infobox" }
const _hoisted_72 = { class: "text-box1" }
const _hoisted_73 = { class: "text-box" }
const _hoisted_74 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_76 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_77 = {
  key: 2,
  class: "nodata"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  style: {"width":"80px","height":"80px"}
}, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text1" }, "暂无内容", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text2" }, "没有搜到想要的内容？您可 联系我们 进行咨询", -1))
const _hoisted_81 = [
  _hoisted_78,
  _hoisted_79,
  _hoisted_80
]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"66px","width":"100px"} }, null, -1))

import { reactive, toRefs, ref,onMounted} from 'vue' 
import mytitle from '../title.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {
        type: String,
        default: ''
    },

    placeholder: {
        type: String,
        default: ''
    },
    type: {
        type: String,
        default: ''
    }
},
  setup(__props) {

const props = __props

let total = ref(0)

onMounted(() => {
    noreginList.value = reginList.value
    let aa = JSON.parse(JSON.stringify(reginList.value))
    aa.map(item => {
        item.platformList = []
    }
    )
    cityList.value = aa
})
let PlatformParms = ref({
    platformName: '',
})
//地级市
let reginList = ref(
    [
        {
            "id": 11,
            "parentId": 0,
            "title": "北京市",
            "key": "11",
            "value": "11",
            "hasChildren": true
        },
        {
            "id": 12,
            "parentId": 0,
            "title": "天津市",
            "key": "12",
            "value": "12",
            "hasChildren": true
        },
        {
            "id": 13,
            "parentId": 0,
            "title": "河北省",
            "key": "13",
            "value": "13",
            "hasChildren": true
        },
        {
            "id": 14,
            "parentId": 0,
            "title": "山西省",
            "key": "14",
            "value": "14",
            "hasChildren": true
        },
        {
            "id": 15,
            "parentId": 0,
            "title": "内蒙古",
            "key": "15",
            "value": "15",
            "hasChildren": true
        },
        {
            "id": 21,
            "parentId": 0,
            "title": "辽宁省",
            "key": "21",
            "value": "21",
            "hasChildren": true
        },
        {
            "id": 22,
            "parentId": 0,
            "title": "吉林省",
            "key": "22",
            "value": "22",
            "hasChildren": true
        },
        {
            "id": 23,
            "parentId": 0,
            "title": "黑龙江省",
            "key": "23",
            "value": "23",
            "hasChildren": true
        },
        {
            "id": 31,
            "parentId": 0,
            "title": "上海市",
            "key": "31",
            "value": "31",
            "hasChildren": true
        },
        {
            "id": 32,
            "parentId": 0,
            "title": "江苏省",
            "key": "32",
            "value": "32",
            "hasChildren": true
        },
        {
            "id": 33,
            "parentId": 0,
            "title": "浙江省",
            "key": "33",
            "value": "33",
            "hasChildren": true
        },
        {
            "id": 34,
            "parentId": 0,
            "title": "安徽省",
            "key": "34",
            "value": "34",
            "hasChildren": true
        },
        {
            "id": 35,
            "parentId": 0,
            "title": "福建省",
            "key": "35",
            "value": "35",
            "hasChildren": true
        },
        {
            "id": 36,
            "parentId": 0,
            "title": "江西省",
            "key": "36",
            "value": "36",
            "hasChildren": true
        },
        {
            "id": 37,
            "parentId": 0,
            "title": "山东省",
            "key": "37",
            "value": "37",
            "hasChildren": true
        },
        {
            "id": 41,
            "parentId": 0,
            "title": "河南省",
            "key": "41",
            "value": "41",
            "hasChildren": true
        },
        {
            "id": 42,
            "parentId": 0,
            "title": "湖北省",
            "key": "42",
            "value": "42",
            "hasChildren": true
        },
        {
            "id": 43,
            "parentId": 0,
            "title": "湖南省",
            "key": "43",
            "value": "43",
            "hasChildren": true
        },
        {
            "id": 44,
            "parentId": 0,
            "title": "广东省",
            "key": "44",
            "value": "44",
            "hasChildren": true
        },
        {
            "id": 46,
            "parentId": 0,
            "title": "海南省",
            "key": "46",
            "value": "46",
            "hasChildren": true
        },
        {
            "id": 45,
            "parentId": 0,
            "title": "广西",
            "key": "45",
            "value": "45",
            "hasChildren": true
        },

        {
            "id": 50,
            "parentId": 0,
            "title": "重庆市",
            "key": "50",
            "value": "50",
            "hasChildren": true
        },
        {
            "id": 51,
            "parentId": 0,
            "title": "四川省",
            "key": "51",
            "value": "51",
            "hasChildren": true
        },
        {
            "id": 52,
            "parentId": 0,
            "title": "贵州省",
            "key": "52",
            "value": "52",
            "hasChildren": true
        },
        {
            "id": 53,
            "parentId": 0,
            "title": "云南省",
            "key": "53",
            "value": "53",
            "hasChildren": true
        },
        {
            "id": 54,
            "parentId": 0,
            "title": "西藏",
            "key": "54",
            "value": "54",
            "hasChildren": true
        },
        {
            "id": 61,
            "parentId": 0,
            "title": "陕西省",
            "key": "61",
            "value": "61",
            "hasChildren": true
        },
        {
            "id": 62,
            "parentId": 0,
            "title": "甘肃省",
            "key": "62",
            "value": "62",
            "hasChildren": true
        },
        {
            "id": 63,
            "parentId": 0,
            "title": "青海省",
            "key": "63",
            "value": "63",
            "hasChildren": true
        },
        {
            "id": 64,
            "parentId": 0,
            "title": "宁夏",
            "key": "64",
            "value": "64",
            "hasChildren": true
        },
        {
            "id": 65,
            "parentId": 0,
            "title": "新疆",
            "key": "65",
            "value": "65",
            "hasChildren": true
        },


        {
            "id": 99,
            "parentId": 0,
            "title": "新疆兵团",
            "key": "99",
            "value": "99",
            "hasChildren": true
        },


    ])


//地级市
let noreginList = ref([])

//省级

let platformList = ref([
  {
    createTime: "2024-12-19 09:15:44",
    provinceName: "湖北省",
    provinceCode: "42",
    isNew: true,
    sort: 5,
    platformList: [],
    firstPlatform: {
      id: "1869552157550780418",
      platformCode: "",
      platformName: "湖北省电子招投标交易平台",
      platformUrl: "",
      platformOrgName: "湖北省公共资源交易中心",
      platformOrgCode: "12420000767423658J",
      platformContactName: !props.type ? "李炜" : "何处",
      platformContactPhone: !props.type ? "13886032676" : "15392940611",
      platformLogo: props.type === '1' ? require("@/assets/img/hblogo1.png") : props.type === '2' ? require("@/assets/img/hblogo2.png") : require("@/assets/img/image.png"),
      createUserName: "",
      updateUserName: "",
      createTime: props.type === '1' ? "2025/03/30 11:20:35" : props.type === '2' ? "2025/03/30 12:25:28" : "2025/03/30 18:30:56",
      platformRegionName: "湖北省",
    },
  },
]);
noreginList.value = reginList.value.filter(
  (item) => !platformList.value.some((item2) => item2.provinceCode == item.key)
);
let cityList = ref([{ platformList: [] }])

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(mytitle, {
          title: __props.title,
          color: "white",
          style: {"margin-top":"64px"}
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            modelValue: _unref(PlatformParms).platformName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(PlatformParms).platformName) = $event)),
            placeholder: __props.placeholder,
            class: "paperview-input-text"
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "searchbtn"
          }, {
            default: _withCtx(() => [
              _createTextVNode("搜索")
            ]),
            _: 1
          })
        ])
      ]),
      (!_ctx.isSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, "省级（" + _toDisplayString(_unref(platformList).length) + "）", 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platformList), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  onMouseover: ($event: any) => (item.isHovered = true),
                  onMouseout: ($event: any) => (item.isHovered = false),
                  onClick: ($event: any) => (_ctx.toPlatform(item.firstPlatform)),
                  style: {"cursor":"pointer"}
                }, [
                  _withDirectives(_createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: item.firstPlatform.platformLogo,
                      alt: "",
                      class: "appimgbox",
                      style: _normalizeStyle(__props.type === '1' && 'height: 40px;')
                    }, null, 12, _hoisted_9),
                    (item.isNew)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, !item.isHovered]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: item.firstPlatform.platformLogo,
                        alt: "",
                        class: "appimgn",
                        style: _normalizeStyle(__props.type === '1' && 'height: 40px;padding: 20px 0;')
                      }, null, 12, _hoisted_13)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(item.firstPlatform.platformContactName), 1),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(item.firstPlatform.platformContactPhone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("span", _hoisted_19, _toDisplayString(item.firstPlatform.createTime), 1)
                    ])
                  ], 512), [
                    [_vShow, item.isHovered]
                  ])
                ], 40, _hoisted_7))
              }), 256)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(noreginList), (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: {"cursor":"pointer"},
                  key: n
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(n.title), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_22, "地级市（" + _toDisplayString(_unref(total)) + "）", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(item.provinceName ? item.provinceName : item.title), 1),
                  _createElementVNode("div", _hoisted_25, " 共加入 " + _toDisplayString(item.platformList.length) + " 家", 1)
                ]),
                _createElementVNode("div", {
                  style: {"width":"1200px","margin-left":"-27px"},
                  onMouseenter: ($event: any) => (item.isHovered2 = true),
                  onMouseleave: ($event: any) => (item.isHovered2 = false)
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      (item.platformList.length > 6)
                        ? (_openBlock(), _createBlock(_component_swiper, {
                            key: 0,
                            slidesPerView: 6,
                            spaceBetween: 0,
                            autoplay: {
                                    delay: 2500,
                                    disableOnInteraction: false
                                },
                            loop: true,
                            navigation: _ctx.navigation,
                            modules: _ctx.modules,
                            class: "mySwiper"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.platformList, (item2, index) => {
                                return (_openBlock(), _createBlock(_component_swiper_slide, {
                                  onMouseover: ($event: any) => (item2.isHovered = true),
                                  key: index,
                                  onMouseout: ($event: any) => (item2.isHovered = false),
                                  onClick: ($event: any) => (_ctx.toPlatform(item2)),
                                  style: {"cursor":"pointer"}
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("img", {
                                        src: item2.platformLogo,
                                        alt: "",
                                        class: "appimgbox",
                                        style: _normalizeStyle(__props.type === '1' && 'height: 40px;')
                                      }, null, 12, _hoisted_30),
                                      (item2.isNew)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                                        : _createCommentVNode("", true),
                                      (_ctx.showcity(item2.platformRegionName))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.showcity(item2.platformRegionName)), 1))
                                        : _createCommentVNode("", true)
                                    ], 512), [
                                      [_vShow, !item2.isHovered]
                                    ]),
                                    _withDirectives(_createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("img", {
                                          src: item2.platformLogo,
                                          alt: "",
                                          class: "appimgn"
                                        }, null, 8, _hoisted_35)
                                      ]),
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, _toDisplayString(item2.platformContactName), 1),
                                        _createElementVNode("div", _hoisted_38, _toDisplayString(item2.platformContactPhone), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_39, [
                                        _hoisted_40,
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(item2.createTime), 1)
                                      ])
                                    ], 512), [
                                      [_vShow, item2.isHovered]
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onMouseover", "onMouseout", "onClick"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["navigation", "modules"]))
                        : _createCommentVNode("", true),
                      (item.platformList.length <= 6)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.platformList, (item2, index2) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index2,
                              onMouseover: ($event: any) => (item2.isHovered = true),
                              onMouseout: ($event: any) => (item2.isHovered = false),
                              onClick: ($event: any) => (_ctx.toPlatform(item2)),
                              style: {"cursor":"pointer"}
                            }, [
                              _withDirectives(_createElementVNode("div", _hoisted_43, [
                                _createElementVNode("img", {
                                  src: item2.platformLogo,
                                  alt: "",
                                  class: "appimgbox",
                                  style: _normalizeStyle(__props.type === '1' && 'height: 40px;')
                                }, null, 12, _hoisted_44),
                                (item2.isNew)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                                  : _createCommentVNode("", true),
                                (_ctx.showcity(item2.platformRegionName))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.showcity(item2.platformRegionName)), 1))
                                  : _createCommentVNode("", true)
                              ], 512), [
                                [_vShow, !item2.isHovered]
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("img", {
                                    src: item2.platformLogo,
                                    alt: "",
                                    class: "appimgn"
                                  }, null, 8, _hoisted_49)
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("div", _hoisted_51, _toDisplayString(item2.platformContactName), 1),
                                  _createElementVNode("div", _hoisted_52, _toDisplayString(item2.platformContactPhone), 1)
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _hoisted_54,
                                  _createElementVNode("span", _hoisted_55, _toDisplayString(item2.createTime), 1)
                                ])
                              ], 512), [
                                [_vShow, item2.isHovered]
                              ])
                            ], 40, _hoisted_42))
                          }), 128))
                        : _createCommentVNode("", true),
                      (item.platformList.length < 6)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList(6, (item2, index3) => {
                            return _createElementVNode("div", {
                              key: index3,
                              style: {"cursor":"pointer"}
                            }, _hoisted_57)
                          }), 64))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      class: "swiper-button-prev",
                      onClick: _withModifiers(($event: any) => (_ctx.prevEl(item, index)), ["stop"])
                    }, [
                      _createElementVNode("div", {
                        class: "delStep",
                        style: {"position":"absolute","left":"-35px","top":"5px"},
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevCarousel && _ctx.prevCarousel(...args)))
                      }, _hoisted_60)
                    ], 8, _hoisted_58), [
                      [_vShow, item.platformList.length > 6 && item.isHovered2]
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      class: "swiper-button-next swiper-button-next1",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextEl && _ctx.nextEl(...args)), ["stop"]))
                    }, [
                      _createElementVNode("div", {
                        class: "delStep",
                        style: {"position":"absolute","right":"-35px","top":"5px"},
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addstep && _ctx.addstep(...args)))
                      }, _hoisted_62)
                    ], 512), [
                      [_vShow, item.platformList.length > 6 && item.isHovered2]
                    ])
                  ])
                ], 40, _hoisted_26)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            (_ctx.searchPlatform.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchPlatform, (item2, index2) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index2,
                      onMouseover: ($event: any) => (item2.isHovered = true),
                      onMouseout: ($event: any) => (item2.isHovered = false),
                      onClick: ($event: any) => (_ctx.toPlatform(item2)),
                      style: {"cursor":"pointer"}
                    }, [
                      _withDirectives(_createElementVNode("div", _hoisted_66, [
                        _createElementVNode("img", {
                          src: item2.platformLogo,
                          alt: "",
                          class: "appimgbox",
                          style: _normalizeStyle(__props.type === '1' && 'height: 40px;')
                        }, null, 12, _hoisted_67)
                      ], 512), [
                        [_vShow, !item2.isHovered]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("img", {
                            src: item2.platformLogo,
                            alt: "",
                            class: "appimgn"
                          }, null, 8, _hoisted_70)
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, _toDisplayString(item2.platformContactName), 1),
                          _createElementVNode("div", _hoisted_73, _toDisplayString(item2.platformContactPhone), 1)
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _hoisted_75,
                          _createElementVNode("span", _hoisted_76, _toDisplayString(item2.createTime), 1)
                        ])
                      ], 512), [
                        [_vShow, item2.isHovered]
                      ])
                    ], 40, _hoisted_65))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.showmoreBtn)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btnmore",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addPage(_unref(PlatformParms).platformName)))
                }, " 查看更多 "))
              : _createCommentVNode("", true),
            (_ctx.searchPlatform.length < 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_81))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_82
  ]))
}
}

})